import Rma from './ui/rma';

export default Rma;
